module.exports = __webpack_public_path__ + "static/media/trophy_bg.61a09176.jpg";